import { render, staticRenderFns } from "./uusi-tyoskentelyjakso.vue?vue&type=template&id=6094c2e2&scoped=true&"
import script from "./uusi-tyoskentelyjakso.vue?vue&type=script&lang=ts&"
export * from "./uusi-tyoskentelyjakso.vue?vue&type=script&lang=ts&"
import style0 from "./uusi-tyoskentelyjakso.vue?vue&type=style&index=0&id=6094c2e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6094c2e2",
  null
  
)

export default component.exports